// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestedPermissionsPanel__container-adaca0 {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.RequestedPermissionsPanel__back-icon-cef6c8 {
  width: 36px;
  height: 36px;
  min-width: 36px;
  margin-inline-end: 16px;
  padding-top: 8px;
  padding-inline-start: 6px;
}

.RequestedPermissionsPanel__header-container-e0f3f2 {
  display: flex;
  padding: 0 16px;
  align-items: center;
  height: 72px;
}

.RequestedPermissionsPanel__content-dcc359 {
  flex: 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.RequestedPermissionsPanel__title-b1f8f8 {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--addition-50);
}

.RequestedPermissionsPanel__menuButton-f618d7 {
  margin-inline-end: 16px;
  width: 36px;
  height: 36px;
  min-width: 36px;
}

.RequestedPermissionsPanel__menu-a55d81 {
  background-color: var(--light-10-addition-120);
  width: 280px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RequestedPermissionsPanel/RequestedPermissionsPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,8CAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.back-icon {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  margin-inline-end: 16px;\n  padding-top: 8px;\n  padding-inline-start: 6px;\n}\n\n.header-container {\n  display: flex;\n  padding: 0 16px;\n  align-items: center;\n  height: 72px;\n}\n\n.content {\n  flex: 1 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--addition-50);\n}\n\n.menuButton {\n  margin-inline-end: 16px;\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n}\n\n.menu {\n  background-color: var(--light-10-addition-120);\n  width: 280px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RequestedPermissionsPanel__container-adaca0`,
	"back-icon": `RequestedPermissionsPanel__back-icon-cef6c8`,
	"backIcon": `RequestedPermissionsPanel__back-icon-cef6c8`,
	"header-container": `RequestedPermissionsPanel__header-container-e0f3f2`,
	"headerContainer": `RequestedPermissionsPanel__header-container-e0f3f2`,
	"content": `RequestedPermissionsPanel__content-dcc359`,
	"title": `RequestedPermissionsPanel__title-b1f8f8`,
	"menuButton": `RequestedPermissionsPanel__menuButton-f618d7`,
	"menu": `RequestedPermissionsPanel__menu-a55d81`
};
module.exports = ___CSS_LOADER_EXPORT___;
